export default window._cmsContent['solar/register-for-updates']